import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { truncateText } from 'utils/renderMaxLengthText';
import { MultilineText } from 'utils/renderMultilineText';
import styles from './AlertModal.module.scss';

export default function AlertModal({
  open,
  type = 'success',
  onClose,
  closeOnOverlay = true,
  onAutoClose,
  gateway = 'claropagosgate',
  message = '',
  messageByLines = {},
}) {
  const assets = useSelector(state => state.asset);
  const paymentMethodsExperienceConfigByRegion = useSelector(
    selectMetadataKeyByRegion('payment_method_modals_config'),
  );

  const {
    modal_add_error_seconds,
    modal_add_confirmation_seconds,
    modal_update_confirmation_seconds,
  } = paymentMethodsExperienceConfigByRegion || {};

  let keyForSecondsToUse;
  switch (type) {
    case 'successUpdate':
      keyForSecondsToUse = modal_update_confirmation_seconds;
      break;
    case 'success':
      keyForSecondsToUse = modal_add_confirmation_seconds;
      break;
    default:
      keyForSecondsToUse = modal_add_error_seconds;
      break;
  }

  const timeToShowModal = (keyForSecondsToUse || 3) * 1000;

  const successIcon = assets?.Icono_Correcto || '';
  const errorIcon = assets?.Icono_Incorrecto || '';
  const icon =
    type === 'success' || type === 'successUpdate' ? successIcon : errorIcon;

  useEffect(
    () => {
      if (!open) return;

      const timer = setTimeout(() => {
        onClose?.();
        onAutoClose?.();
      }, timeToShowModal);

      return () => clearTimeout(timer);
    },
    [open, timeToShowModal, onClose, onAutoClose],
  );

  const indexToBold = type === 'success' ? 0 : 1;

  const fullText = Object.values(messageByLines).join(' ');
  const truncatedText = truncateText(fullText, 95);

  const truncatedLines = Object.keys(messageByLines).reduce(
    (acc, key) => {
      if (!acc.remaining) return acc;

      const original = messageByLines[key];
      const slice = acc.remaining.slice(0, original.length);

      acc.remaining = acc.remaining.slice(slice.length).trimStart();
      acc.result.push(slice);

      return acc;
    },
    { result: [], remaining: truncatedText },
  ).result;

  if (!open) return null;

  return (
    <div
      className={styles.overlay}
      onClick={closeOnOverlay ? onClose : undefined}
    >
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.iconContainer}>
          {icon ? (
            <img className={styles.icon} src={icon} />
          ) : (
            <span className={styles.icon} />
          )}
        </div>

        <p className={styles.message}>
          {truncatedLines.length > 0 ? (
            truncatedLines.map((text, i) => (
              <span
                key={i}
                style={{ fontWeight: i === indexToBold ? 700 : 400 }}
              >
                {text}{' '}
              </span>
            ))
          ) : (
            <MultilineText
              text={message}
              maxLines={type === 'error' ? 3 : 2}
              maxCharsPerLine={32}
            />
          )}
        </p>
      </div>
    </div>
  );
}
